import { DAYS } from 'Data/constants.js'

export default function useDataTransform(props, data) {
  return DAYS
}
